module.exports = __webpack_public_path__ + "img/science.cf3c93f1.jpg";